<template>

  <h2>Zoznam kurzov</h2>

  <!-- Navigácia mesiacov -->
  <v-row align="center" style="margin:1px">
    <v-btn v-if="toggle_select<3" size="small" variant="outlined" style="margin-right:8px;" @click="prevMonth">‹</v-btn>
    <span v-if="toggle_select<3" style="margin-right:8px; font-weight:bold">{{ formatMonthLabel(currentYear, currentMonth) }}</span>
    <v-btn v-if="toggle_select<3" size="small" variant="outlined" style="margin-right:1px" @click="nextMonth">›</v-btn>
    <v-btn v-if="toggle_select<3" size="small" variant="outlined" style="margin-right:1px" @click="goToday">Dnes</v-btn>
    <v-spacer />
    <v-btn size="small" variant="outlined" style="margin-right:1px" @click="toggle_select = 0">Kalendár</v-btn>
    <v-btn size="small" variant="outlined" style="margin-right:1px" @click="toggle_select = 1">Zoznam</v-btn>
    <v-btn size="small" variant="outlined" style="margin-left:8px" @click="toggle_select = 3">Moje školenia</v-btn>
  </v-row>

  <!-- Filtre: 2 skupiny -->
  <v-row align="center" style="margin:6px 1px" v-if="toggle_select<3">
    <span style="margin-right:6px"><b>Miesto:</b></span>
    <v-btn
      size="x-small" variant="outlined" style="margin-right:4px"
      :color="isVenueOn('OBJ') ? 'success' : ''"
      @click="toggleVenue('OBJ')"
    >
      U objednávateľa
    </v-btn>
    <v-btn
      size="x-small" variant="outlined" style="margin-right:16px"
      :color="isVenueOn('UKF') ? 'success' : ''"
      @click="toggleVenue('UKF')"
    >
      UKF
    </v-btn>

    <span style="margin-right:6px"><b>Skupina:</b></span>
    <v-btn
      size="x-small" variant="outlined" style="margin-right:4px"
      :color="isAudienceOn('ST') ? 'success' : ''"
      @click="toggleAudience('ST')"
    >
      Študenti/Žiaci
    </v-btn>
    <v-btn
      size="x-small" variant="outlined" style="margin-right:8px"
      :color="isAudienceOn('UC') ? 'success' : ''"
      @click="toggleAudience('UC')"
    >
      Učitelia
    </v-btn>

    <v-btn size="x-small" variant="outlined" @click="clearFilters">Vymazať</v-btn>

    <v-spacer />
    <span v-for="tag in legendTags" :key="tag.key" :style="legendStyle(tag.key)">{{ tag.label }}</span>
  </v-row>

  <!-- Kalendár -->
  <v-card-text v-if="toggle_select==0">
    <table border="1" style="padding:0px;spacing:0px;border-collapse:collapse;width:100%;table-layout:fixed">
      <tr style="background:#f5f5f5">
        <th v-for="d in ['Po','Ut','St','Št','Pi','So','Ne']" :key="d" style="background-color:#2E7D32;color:white;padding:5px;width:14.2857%">{{ d }}</th>
      </tr>
      <tr v-for="(week, wi) in weeks" :key="wi">
        <td v-for="(day, di) in week" :key="di" valign="top" :style="getDayCellStyle(day)">
          <div style="display:flex;justify-content:space-between;align-items:center">
            <span style="font-weight:bold">{{ day.day }}</span>
            <v-icon v-if="day.isToday" style="color:#2E7D32" size="14px" title="Dnes">fiber_manual_record</v-icon>
          </div>

          <!-- udalosti v dni -->
          <v-tooltip v-for="(sk, si) in day.skolenia" :key="sk.iid || si" location="top">
            <template #activator="{ props }">
              <v-card
                v-bind="props"
                variant="outlined"
                :style="getCourseCardStyle(sk)"
              >
                <v-card-text style="margin:-5px">
                  <div style="font-weight:600; white-space:normal; word-break:break-word; line-height:1.2">{{ sk.nazov }}</div>
                  <div style="font-size:12px">{{ sk.cas }}</div>
                  <div style="font-size:12px">Prihlásení: {{ safeCount(sk) }} / {{ effectiveMax(sk) }}</div>

                  <div v-if="!isFull(sk)" style="display:flex;justify-content:center;margin-top:4px">
                    <v-btn size="x-small" variant="outlined" @click.stop="openSignup(sk)">Prihlásiť</v-btn>
                  </div>

                  <div style="margin-top:3px">
                    <span v-for="chip in makeChips(sk)" :key="chip.key" :style="chipStyle(chip.key)">{{ chip.label }}</span>
                  </div>
                </v-card-text>
              </v-card>
            </template>

            <div style="max-width:380px">
              <div style="font-weight:bold;margin-bottom:4px">{{ sk.nazov }}</div>
              <div><b>Dátum:</b> {{ sk.datum }} &nbsp; <b>Čas:</b> {{ sk.cas || '—' }}</div>
              <div><b>Miesto:</b> {{ sk.miesto_konania || '—' }}</div>
              <div><b>Cieľová skupina:</b> {{ sk.cielova_skupina || '—' }}</div>
              <div><b>Dĺžka:</b> {{ sk.dlzka || '—' }}</div>
              <div><b>Požadované znalosti:</b> {{ sk.pozadovane_znalosti || '—' }}</div>
              <div><b>Technické vybavenie:</b> {{ sk.technicke_vybavenie || '—' }}</div>
              <div><b>Účastníci:</b> prihlásení {{ safeCount(sk) }} / max {{ effectiveMax(sk) }} <span v-if="sk.min_ucastnikov"> (min {{ sk.min_ucastnikov }})</span></div>
              <div><b>Poznámky:</b> {{ sk.poznamky || '—' }}</div>
              <div><b>Skratka:</b> {{ sk.skratka || '—' }}</div>
            </div>
          </v-tooltip>

        </td>
      </tr>
    </table>
  </v-card-text>

  <!-- Zoznam -->
  <v-card-text v-if="toggle_select==1">
    <table border="1" style="padding:0px;spacing:0px;border-collapse:collapse;width:100%">
      <tr style="background-color:#2E7D32;color:white;padding:5px">
        <th style="padding:5px">Dátum</th>
        <th style="padding:5px">Čas</th>
        <th style="padding:5px">Názov</th>
        <th style="padding:5px">Popis (miesto, cieľová skupina)</th>
        <th style="padding:5px">Požadované znalosti</th>
        <th style="padding:5px">Technické vybavenie</th>
        <th style="padding:5px">Prihl./Min/Max</th>
        <th style="padding:5px">Akcia</th>
        <th style="padding:5px">Poznámky</th>
      </tr>
      <tr v-for="(sk, i) in zoznamSkoleni" :key="sk.iid || i" :style="getListRowStyle(sk)">
        <td style="padding:5px">{{ sk.datum }}</td>
        <td style="padding:5px">{{ sk.cas }}</td>
        <td style="padding:5px">
          <v-tooltip location="top">
            <template #activator="{ props }">
              <span v-bind="props" style="white-space:normal; word-break:break-word; line-height:1.2">{{ sk.nazov }}</span>
            </template>
            <div style="max-width:380px">
              <div style="font-weight:bold;margin-bottom:4px">{{ sk.nazov }}</div>
              <div><b>Dátum:</b> {{ sk.datum }} &nbsp; <b>Čas:</b> {{ sk.cas || '—' }}</div>
              <div><b>Miesto:</b> {{ sk.miesto_konania || '—' }}</div>
              <div><b>Cieľová skupina:</b> {{ sk.cielova_skupina || '—' }}</div>
              <div><b>Dĺžka:</b> {{ sk.dlzka || '—' }}</div>
              <div><b>Požadované znalosti:</b> {{ sk.pozadovane_znalosti || '—' }}</div>
              <div><b>Technické vybavenie:</b> {{ sk.technicke_vybavenie || '—' }}</div>
              <div><b>Účastníci:</b> prihlásení {{ safeCount(sk) }} / max {{ effectiveMax(sk) }} <span v-if="sk.min_ucastnikov"> (min {{ sk.min_ucastnikov }})</span></div>
              <div><b>Skratka:</b> {{ sk.skratka || '—' }}</div>
              <div style="margin-top:4px">
                <span v-for="chip in makeChips(sk)" :key="chip.key" :style="chipStyle(chip.key)">{{ chip.label }}</span>
              </div>
            </div>
          </v-tooltip>
        </td>
        <td style="padding:5px">
          <div>{{ sk.miesto_konania }}</div>
          <div style="font-size:12px;color:#555">{{ sk.cielova_skupina }}</div>
          <div style="margin-top:4px">
            <span v-for="chip in makeChips(sk)" :key="chip.key" :style="chipStyle(chip.key)">{{ chip.label }}</span>
          </div>
        </td>
        <td style="padding:5px">{{ sk.pozadovane_znalosti }}</td>
        <td style="padding:5px">{{ sk.technicke_vybavenie }}</td>
        <td style="padding:5px" align="center">
          {{ safeCount(sk) }} / <span v-if="sk.min_ucastnikov">{{ sk.min_ucastnikov }}/</span>{{ effectiveMax(sk) }}
        </td>
        <td style="padding:5px" align="center">
          <v-btn size="x-small" variant="outlined" :disabled="isFull(sk)" @click="openSignup(sk)">
            {{ isFull(sk) ? 'Obsadené' : 'Prihlásiť' }}
          </v-btn>
        </td>
        <td style="padding:5px">{{ sk.poznamky }}</td>
      </tr>
    </table>
  </v-card-text>

  <!-- Modálne okno prihlásenia -->
  <v-dialog v-model="signupDialog" max-width="640">
    <v-card>
      <v-card-title style="font-weight:bold">Prihlásenie na školenie</v-card-title>
      <v-card-text v-if="selectedCourse">
        <div style="margin-bottom:8px;">
          <div><b>Názov:</b> {{ selectedCourse.nazov }}</div>
          <div><b>Dátum/čas:</b> {{ selectedCourse.datum }} {{ selectedCourse.cas || '' }}</div>
          <div><b>Miesto:</b> {{ selectedCourse.miesto_konania }}</div>
          <div><b>Cieľová skupina:</b> {{ selectedCourse.cielova_skupina }}</div>
          <div><b>Kapacita:</b> {{ safeCount(selectedCourse) }} / {{ effectiveMax(selectedCourse) }}</div>
        </div>

        <div v-if="venueKeyFrom(selectedCourse.miesto_konania) === 'OBJ'">
          <h4 style="margin:6px 0">Údaje objednávateľa</h4>
          <v-text-field v-model="form.obj_email" label="E-mail kontaktnej osoby" type="email" density="compact" variant="outlined" hide-details="auto" style="margin-top:8px"/>
          <v-text-field v-model.number="form.obj_pocet_ziakov" label="Počet účastníkov" type="number" min="1" density="compact" variant="outlined" hide-details="auto" style="margin-top:8px"/>
          <v-text-field v-model="form.obj_nazov_skoly" label="Názov školy" density="compact" variant="outlined" hide-details="auto" style="margin-top:8px"/>
          <v-text-field v-model="form.obj_adresa_skoly" label="Adresa školy" density="compact" variant="outlined" hide-details="auto" style="margin-top:8px"/>
          <v-textarea v-model="form.poznamka" label="Poznámka (voliteľné)" rows="2" density="compact" variant="outlined" hide-details="auto" style="margin-top:8px"/>
          <div style="font-size:12px;color:#555;margin-top:6px">* Pri „U objednávateľa“ je maximálna kapacita 1 (ak ju backend nešpecifikuje).</div>
        </div>

        <div v-else>
          <h4 style="margin:6px 0">Účastník</h4>
          <div style="font-size:13px;color:#555">
            Prihlásenie na školenie na UKF. Údaje o prihlásenom budú automaticky doplnené zo systému.
          </div>
          <v-textarea v-model="form.poznamka" label="Poznámka (voliteľné)" rows="2" density="compact" variant="outlined" hide-details="auto" />
        </div>

        <div v-if="signupError" style="color:#b71c1c; margin-top:6px">{{ signupError }}</div>
        <div v-if="signupOk" style="color:#2E7D32; margin-top:6px">{{ signupOk }}</div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn variant="outlined" @click="closeSignup">Zrušiť</v-btn>
        <v-btn variant="outlined" :disabled="submitting || !canSubmit" @click="submitSignup">
          {{ submitting ? 'Odosielam…' : 'Odoslať prihlášku' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Moje školenia -->
  <v-card v-if="toggle_select==3">
    <v-card-title style="font-weight:bold">Moje školenia</v-card-title>
    <v-card-text>
      <table border="1" style="padding:0px;spacing:0px;border-collapse:collapse;width:100%">
        <tr style="background-color:#2E7D32;color:white;padding:5px">
          <th style="padding:5px">Dátum</th>
          <th style="padding:5px">Čas</th>
          <th style="padding:5px">Názov</th>
          <th style="padding:5px">Miesto</th>
          <th style="padding:5px">Skupina</th>
          <th style="padding:5px">Prihl./Min/Max</th>
          <th style="padding:5px">Moje údaje</th>
          <th style="padding:5px">Akcia</th>
        </tr>

        <tr v-if="mySkoleniaSorted.length===0">
          <td colspan="8" style="padding:10px; text-align:center; color:#555">
            Zatiaľ nemáš žiadne školenia.
          </td>
        </tr>

        <tr v-for="(it, i) in mySkoleniaSorted" :key="it.id || i" :style="getListRowStyle(it)">
          <td style="padding:5px">{{ it.datum }}</td>
          <td style="padding:5px">{{ it.cas }}</td>
          <td style="padding:5px">
            <div style="white-space:normal; word-break:break-word; line-height:1.2; font-weight:600">{{ it.nazov }}</div>
            <div style="margin-top:4px">
              <span v-for="chip in makeChips(it)" :key="chip.key" :style="chipStyle(chip.key)">{{ chip.label }}</span>
            </div>
          </td>
          <td style="padding:5px">{{ it.miesto_konania }}</td>
          <td style="padding:5px">{{ it.cielova_skupina }}</td>
          <td style="padding:5px" align="center">
            {{ safeCount(it) }} / <span v-if="it.min_ucastnikov">{{ it.min_ucastnikov }}/</span>{{ effectiveMax(it) }}
          </td>
          <td style="padding:5px">
            <div v-if="venueKeyFrom(it.miesto_konania)==='OBJ'">
              <div><b>Kontakt:</b> {{ it.email_kontakt || '—' }}</div>
              <div><b>Škola:</b> {{ it.zaujemca || it.nazov_skoly || '—' }}</div>
              <div><b>Adresa:</b> {{ it.adresa_skoly || '—' }}</div>
              <div><b>Počet účastníkov:</b> {{ it.pocet_ucastnikov || 1 }}</div>
            </div>
            <div v-else>
              <div><b>Účastník:</b> {{ it.zaujemca || '—' }}</div>
            </div>
            <div v-if="it.poznamka" style="margin-top:4px"><b>Poznámka:</b> {{ it.poznamka }}</div>
          </td>
          <td style="padding:5px" align="center">
            <v-btn
              v-if="venueKeyFrom(it.miesto_konania)==='UKF'"
              size="x-small"
              variant="outlined"
              color="error"
              @click="confirmDeleteMyCourse(it)"
            >
              Odstrániť
            </v-btn>
            <span v-else style="font-size:12px;color:#777">—</span>
          </td>
        </tr>
      </table>
    </v-card-text>
  </v-card>

</template>

<script>
import axios from '../../axios-auth.js'

export default {
  data() {
    const now = new Date()
    return {
      toggle_select: 0,
      currentYear:  now.getFullYear(),
      currentMonth: now.getMonth() + 1,
      myKalendar: [],
      mySkolenia: [],
      weeks: [],
      eventsByDate: {},
      // 2 skupiny filtrov – ARRAYS kvôli reaktivite (namiesto Set)
      activeVenue: ['OBJ','UKF'],
      activeAudience: ['ST','UC'],

      // Modal / formulár
      signupDialog: false,
      selectedCourse: null,
      form: {
        obj_email: '',
        obj_pocet_ziakov: 1,
        obj_nazov_skoly: '',
        obj_adresa_skoly: '',
        poznamka: ''
      },
      submitting: false,
      signupError: '',
      signupOk: '',

      palette: {
        OBJ: { bg:'#FFF3E0', fg:'#E65100' },
        UKF: { bg:'#E8F5E9', fg:'#2E7D32' },
        ST:  { bg:'#E3F2FD', fg:'#0D47A1' },
        UC:  { bg:'#F3E5F5', fg:'#6A1B9A' },
        DEF: { bg:'#ECEFF1', fg:'#37474F' }
      }
    }
  },

  mounted() {
    this.initData()
  },

  watch: {
    toggle_select(n) {
      // keď prepneš na "Moje školenia", refetchni aktuálny mesiac (prinesie aj my_skolenia)
      if (n === 3) this.fetchMonth(this.currentYear, this.currentMonth)
    }
  },

  computed: {
    zoznamSkoleni() {
      const arr = this.applyFilters(this.myKalendar)
      arr.sort((a,b) => (`${a.datum} ${a.cas||''}` < `${b.datum} ${b.cas||''}` ? -1 : 1))
      return arr
    },
    mySkoleniaSorted() {
      const arr = Array.isArray(this.mySkolenia) ? [...this.mySkolenia] : []
      arr.sort((a,b) => (`${a.datum} ${a.cas||''}` > `${b.datum} ${b.cas||''}` ? -1 : 1))
      return arr
    },
    legendTags() {
      return [
        { key:'OBJ', label:'U objednávateľa' },
        { key:'UKF', label:'UKF' },
        { key:'ST',  label:'Študenti/Žiaci' },
        { key:'UC',  label:'Učitelia' }
      ]
    },
    canSubmit() {
      if (!this.selectedCourse) return false
      const venue = this.venueKeyFrom(this.selectedCourse.miesto_konania)
      if (venue === 'OBJ') {
        return this.form.obj_email && this.form.obj_nazov_skoly && this.form.obj_adresa_skoly && Number(this.form.obj_pocet_ziakov) >= 1
      }
      return true
    }
  },

  methods: {
    /* INIT / FETCH */
    initData() {
      this.$store.commit('setFeedback', null)
      this.fetchMonth(this.currentYear, this.currentMonth)
    },
    fetchMonth(rok, mesiac) {
      const mm = String(mesiac).padStart(2,'0')
      axios.get(`/get-kalendar-skoleni/${rok}/${mm}`, this.$store.getters.getAxiosConfig)
        .then(res => {
          this.myKalendar = Array.isArray(res.data?.skolenia) ? res.data.skolenia : []
          this.mySkolenia = Array.isArray(res.data?.my_skolenia) ? res.data.my_skolenia : []
          if (res.data?.message && res.data.message !== 'OK') this.$store.commit('setFeedback', res.data.message)
          this.prepareCalendar(rok, mesiac)
        })
        .catch(error => {
          this.$store.commit('setFeedback', error.name+': '+error.message)
          this.myKalendar = []
          this.mySkolenia = []
          this.prepareCalendar(rok, mesiac)
        })
    },

    /* CALENDAR */
    prepareCalendar(rok, mesiac) {
      const filtered = this.applyFilters(this.myKalendar)
      const map = {}
      for (const el of filtered) {
        const key = String(el.datum)
        if (!map[key]) map[key] = []
        map[key].push(el)
      }
      Object.keys(map).forEach(k => map[k].sort((a,b) => (a.cas||'') < (b.cas||'') ? -1 : 1))
      this.eventsByDate = map

      const first = new Date(rok, mesiac - 1, 1)
      const last  = new Date(rok, mesiac, 0)
      const days  = last.getDate()
      const jsDow = first.getDay()
      const offset = (jsDow === 0 ? 6 : jsDow - 1)

      const cells = []
      for (let i=0; i<offset; i++) {
        const d = new Date(first); d.setDate(d.getDate() - (offset - i))
        cells.push(this.makeDayCell(d, false))
      }
      for (let day=1; day<=days; day++) {
        const d = new Date(rok, mesiac-1, day)
        cells.push(this.makeDayCell(d, true))
      }
      while (cells.length % 7 !== 0) {
        const d = new Date(last); d.setDate(d.getDate() + (cells.length % 7))
        cells.push(this.makeDayCell(d, false))
      }
      const weeks = []
      for (let i=0; i<cells.length; i+=7) weeks.push(cells.slice(i, i+7))
      this.weeks = weeks
    },
    makeDayCell(dateObj, inMonth) {
      const y = dateObj.getFullYear()
      const m = String(dateObj.getMonth()+1).padStart(2,'0')
      const d = String(dateObj.getDate()).padStart(2,'0')
      const key = `${y}-${m}-${d}`
      const now = new Date()
      const isToday = (y===now.getFullYear() && (dateObj.getMonth()+1)===(now.getMonth()+1) && dateObj.getDate()===now.getDate())
      return { date:key, day:parseInt(d,10), inMonth, isToday, skolenia:this.eventsByDate[key] || [] }
    },

    /* NAV */
    prevMonth(){ let y=this.currentYear, m=this.currentMonth-1; if(m===0){m=12;y--} this.currentYear=y; this.currentMonth=m; this.fetchMonth(y,m) },
    nextMonth(){ let y=this.currentYear, m=this.currentMonth+1; if(m===13){m=1;y++} this.currentYear=y; this.currentMonth=m; this.fetchMonth(y,m) },
    goToday(){ const n=new Date(); this.currentYear=n.getFullYear(); this.currentMonth=n.getMonth()+1; this.fetchMonth(this.currentYear,this.currentMonth) },

    formatMonthLabel(y, m) {
      const names = ['január','február','marec','apríl','máj','jún','júl','august','september','október','november','december']
      return `${names[m-1]} ${y}`
    },
    getDayCellStyle(day) {
      let st = 'height:140px; padding:4px; overflow:auto;'
      if (!day.inMonth) st += 'background:#fafafa;color:#999;'
      if (day.isToday)  st += 'border:2px solid #2E7D32;'
      return st
    },

    /* OBSADENOSŤ & VZHĽAD */
    safeCount(sk) {
      const n = Number(sk?.pocet_prihlasenych ?? 0)
      return isNaN(n) ? 0 : n
    },
    effectiveMax(sk) {
      if (sk?.max_ucastnikov != null) return Number(sk.max_ucastnikov)
      return this.venueKeyFrom(sk?.miesto_konania) === 'OBJ' ? 1 : 0
    },
    isFull(sk) {
      const cnt = this.safeCount(sk)
      const mx  = this.effectiveMax(sk)
      return mx > 0 && cnt >= mx
    },
    getCourseCardStyle(sk) {
      const base = 'margin:2px;cursor:default;overflow:hidden;'
      const bg  = this.isFull(sk) ? '#FFEBEE' : '#E8F5E9'
      const brd = this.isFull(sk) ? '#C62828' : '#2E7D32'
      return `${base}background:${bg};border:1px solid ${brd};`
    },
    getListRowStyle(sk) {
      const bg = this.isFull(sk) ? '#FFEBEE' : ''
      return bg ? `background:${bg};` : ''
    },

    /* ŠTÍTKY / FILTRE */
    makeChips(sk) {
      const chips = []
      const v = this.venueKeyFrom(sk.miesto_konania)
      if (v) chips.push({ key:v, label:this.labelOf(v) })
      const a = this.audienceKeysFrom(sk.cielova_skupina)
      a.forEach(k => chips.push({ key:k, label:this.labelOf(k) }))
      return chips
    },
    labelOf(key) {
      if (key==='OBJ') return 'U objednávateľa'
      if (key==='UKF') return 'UKF'
      if (key==='ST')  return 'Študenti'
      if (key==='UC')  return 'Učitelia'
      return key
    },
    chipStyle(key) {
      const c = this.palette[key] || this.palette.DEF
      return `display:inline-block;margin:1px 4px 0 0;padding:2px 6px;border-radius:10px;font-size:11px;
              background:${c.bg};color:${c.fg};border:1px solid ${c.fg}22;`
    },
    legendStyle(key) { return this.chipStyle(key) },

    // rozpoznanie filtrov
    venueKeyFrom(miesto='') {
      const s = String(miesto).toLowerCase()
      if (s.includes('ukf') || s.includes('univerzit') || s.includes('kampus')) return 'UKF'
      return 'OBJ'
    },
    audienceKeysFrom(cg='') {
      const s = String(cg).toLowerCase()
      const keys = []
      if (s.includes('študenti') || s.includes('žiaci') || s.includes('študent') || s.includes('student')) keys.push('ST')
      if (s.includes('učitelia') || s.includes('ucitel') || s.includes('teacher') || s.includes('pedag')) keys.push('UC')
      return keys
    },

    // FILTRE – ARRAYS
    toggleVenue(key){
      const idx = this.activeVenue.indexOf(key)
      if (idx >= 0) this.activeVenue.splice(idx,1)
      else this.activeVenue.push(key)
      this.prepareCalendar(this.currentYear, this.currentMonth)
    },
    toggleAudience(key){
      const idx = this.activeAudience.indexOf(key)
      if (idx >= 0) this.activeAudience.splice(idx,1)
      else this.activeAudience.push(key)
      this.prepareCalendar(this.currentYear, this.currentMonth)
    },
    isVenueOn(key){ return this.activeVenue.includes(key) },
    isAudienceOn(key){ return this.activeAudience.includes(key) },
    clearFilters(){
      this.activeVenue = []
      this.activeAudience = []
      this.prepareCalendar(this.currentYear, this.currentMonth)
    },

    applyFilters(events) {
      return events.filter(sk => {
        const v = this.venueKeyFrom(sk.miesto_konania)
        const a = this.audienceKeysFrom(sk.cielova_skupina)

        const venueOk = (this.activeVenue.length === 0) || this.activeVenue.includes(v)
        const audienceOk = (this.activeAudience.length === 0) || a.some(k => this.activeAudience.includes(k))
        return venueOk && audienceOk
      })
    },

    /* MODAL: OPEN / CLOSE / SUBMIT */
    openSignup(sk) {
      this.signupError = ''
      this.signupOk = ''
      const iid = Number(sk?.iid)
      this.selectedCourse = { ...sk, iid: Number.isFinite(iid) ? iid : 0 }
      this.form.obj_email = ''
      this.form.obj_pocet_ziakov = 1
      this.form.obj_nazov_skoly = ''
      this.form.obj_adresa_skoly = ''
      this.form.poznamka = ''
      this.signupDialog = true
    },
    closeSignup() {
      this.signupDialog = false
      this.selectedCourse = null
    },
    submitSignup() {
      if (!this.selectedCourse) return
      this.signupError = ''
      this.signupOk = ''
      this.submitting = true

      const iid = Number(this.selectedCourse.iid)
      if (!Number.isFinite(iid) || iid <= 0) {
        this.submitting = false
        this.signupError = 'Chýba identifikátor termínu (iid). Skúste prosím znova.'
        return
      }

      const venue = this.venueKeyFrom(this.selectedCourse.miesto_konania)
      const payload = {
        termin_id: iid,
        typ: venue,
        poznamka: this.form.poznamka || ''
      }

      if (venue === 'OBJ') {
        Object.assign(payload, {
          email_zodpovedny: this.form.obj_email,
          pocet_ziakov: Number(this.form.obj_pocet_ziakov) || 1,
          nazov_skoly: this.form.obj_nazov_skoly,
          adresa_skoly: this.form.obj_adresa_skoly
        })
      }

      axios.post('/skolenie-zapis', payload, this.$store.getters.getAxiosConfig)
        .then((res) => {
          if (res?.data?.message && res.data.message !== 'OK') {
            this.signupError = res.data.message
          } else {
            this.signupOk = 'Prihlásenie prebehlo úspešne.'
            this.fetchMonth(this.currentYear, this.currentMonth) // refresh po zápise
            setTimeout(() => { this.closeSignup() }, 800)
          }
        })
        .catch(err => {
          this.signupError = (err?.response?.data?.message) || (err.name+': '+err.message)
        })
        .finally(() => { this.submitting = false })
    },

    /* MOJE ŠKOLENIA: DELETE */
    confirmDeleteMyCourse(it) {
      const text = `Naozaj chceš odstrániť prihlášku na „${it.nazov}“ (${it.datum} ${it.cas || ''})?`
      if (confirm(text)) this.deleteMyCourse(it)
    },
    deleteMyCourse(it) {
      if (!it?.id) return
      this.$store.commit('setFeedback', null)
      axios.post('/zaujemci-vymaz', { skolenie_id: it.id }, this.$store.getters.getAxiosConfig)
        .then(res => {
          if (res?.data?.message && res.data.message !== 'OK') {
            this.$store.commit('setFeedback', res.data.message)
          } else {
            this.fetchMonth(this.currentYear, this.currentMonth) // refresh po zmazaní
          }
        })
        .catch(err => {
          this.$store.commit('setFeedback', (err?.response?.data?.message) || (err.name+': '+err.message))
        })
    }
  }
}
</script>
